import React from 'react';
import {AddFormDataMethod} from "./AddFormDataMethod";

// 此时的 url 为列表形式
const AddFormComponent = ({UserForm, url}) => {
    const onFinish = (data) => {
        // console.log("data   ", data)
        AddFormDataMethod(data, url[0]);    // 需要的 url 为字符串形式
    }

    return (
        <UserForm onFinish={onFinish} initialValues={{}}/>
    )
};

export default AddFormComponent;
